import { Axis as VisxAxis } from '@visx/axis';

import { _centerEllipsizeText } from '@dynatrace/strato-components/typography';

import { axis } from './Axis.sty.js';
import {
  AXIS_TICK_LENGTH,
  axisFontBaseProps,
  axisFontProps,
} from './constants.js';
import { AxisProps } from './types.js';
import { useComputedFontStyle } from '../../hooks/useComputedFontStyle.js';
import { TextProps, TickLabelProps } from '../../types/text-props.js';
import { TickPrimitiveValue } from '../../types/tick-value.js';

const labelProps: TextProps = { ...axisFontProps, textAnchor: 'middle' };
const labelBaseProps: TextProps = {
  ...axisFontBaseProps,
  textAnchor: 'middle',
};

/**
 * @internal
 */
export const Axis = ({
  width = '100%',
  height = '100%',
  containerSize,
  label,
  size = 'small',
  tickLabelProps = (...args) => ({}),
  ...restProps
}: AxisProps) => {
  const fontProps = size === 'small' ? axisFontProps : axisFontBaseProps;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const defaultTickLabelProps: TickLabelProps<TickPrimitiveValue> = (
    ...args: [TickPrimitiveValue, number, any]
  ) => ({
    ...fontProps,
    ...(typeof tickLabelProps === 'function'
      ? tickLabelProps(...args)
      : tickLabelProps),
  });

  const fontStyle = useComputedFontStyle(fontProps);

  const truncatedLabel = label
    ? _centerEllipsizeText(label, fontStyle, containerSize)
    : '';
  const testId = (restProps as unknown as Record<string, string>)[
    'data-testid'
  ];

  return (
    <svg className={axis} width={width} height={height} data-testid={testId}>
      <VisxAxis
        label={truncatedLabel}
        labelProps={size === 'small' ? labelProps : labelBaseProps}
        tickLabelProps={defaultTickLabelProps}
        tickLength={AXIS_TICK_LENGTH}
        hideTicks
        hideAxisLine
        {...restProps}
      />
    </svg>
  );
};
Axis['displayName'] = 'Axis';
